import { productCodesFilterAtom } from 'atoms/filters/rsim-products';
import { productCodesHintsAtom } from 'atoms/hints/rsim-products';
import { ProductCodeSearchFilter } from 'src/common/components/Filters/Inputs/productCode/ProductCodeSearchFilter';

export const ProductCodesSearchInput = () => {
  return (
    <ProductCodeSearchFilter
      productCodesFilterAtom={productCodesFilterAtom}
      productCodesHintsAtom={productCodesHintsAtom}
    />
  );
};
